import { render, staticRenderFns } from "./PacientesDetalleConsentimientos.vue?vue&type=template&id=cd268d80&"
import script from "./PacientesDetalleConsentimientos.vue?vue&type=script&lang=js&"
export * from "./PacientesDetalleConsentimientos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports